
import { Component, Vue } from "vue-property-decorator";
import ResultadoComponent from "@/components/Formulario2026/ResultadoComponent.vue";

@Component({
  components: {
    ResultadoComponent
  }
})
export default class FormularioTerminadoView extends Vue {}
